import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetBoundaryAuthorityProposalsQueryVariables = Types.Exact<{
  status: Types.Scalars['String']['input'];
}>;


export type GetBoundaryAuthorityProposalsQuery = { __typename?: 'query_root', boundary_authority_proposals: Array<{ __typename?: 'boundary_authority_proposals', id: any, confidence: string, reasoning?: string | null, county_check: string, layer_county?: string | null, registry_county?: string | null, status: string, model_name?: string | null, reviewed_at?: any | null, created_at: any, boundary: { __typename?: 'jurisdiction_boundaries', id: any, name: string, source: string, effective_from: any }, proposed_jurisdiction: { __typename?: 'jurisdictions', id: any, name: string, short_name: string, city?: string | null, county?: string | null, state: string } }> };


export const GetBoundaryAuthorityProposalsDocument = gql`
    query getBoundaryAuthorityProposals($status: String!) {
  boundary_authority_proposals(
    where: {status: {_eq: $status}}
    order_by: {created_at: asc}
  ) {
    id
    confidence
    reasoning
    county_check
    layer_county
    registry_county
    status
    model_name
    reviewed_at
    created_at
    boundary {
      id
      name
      source
      effective_from
    }
    proposed_jurisdiction {
      id
      name
      short_name
      city
      county
      state
    }
  }
}
    `;

/**
 * __useGetBoundaryAuthorityProposalsQuery__
 *
 * To run a query within a React component, call `useGetBoundaryAuthorityProposalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoundaryAuthorityProposalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoundaryAuthorityProposalsQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetBoundaryAuthorityProposalsQuery(baseOptions: Apollo.QueryHookOptions<GetBoundaryAuthorityProposalsQuery, GetBoundaryAuthorityProposalsQueryVariables> & ({ variables: GetBoundaryAuthorityProposalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBoundaryAuthorityProposalsQuery, GetBoundaryAuthorityProposalsQueryVariables>(GetBoundaryAuthorityProposalsDocument, options);
      }
export function useGetBoundaryAuthorityProposalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBoundaryAuthorityProposalsQuery, GetBoundaryAuthorityProposalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBoundaryAuthorityProposalsQuery, GetBoundaryAuthorityProposalsQueryVariables>(GetBoundaryAuthorityProposalsDocument, options);
        }
export function useGetBoundaryAuthorityProposalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBoundaryAuthorityProposalsQuery, GetBoundaryAuthorityProposalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBoundaryAuthorityProposalsQuery, GetBoundaryAuthorityProposalsQueryVariables>(GetBoundaryAuthorityProposalsDocument, options);
        }
export type GetBoundaryAuthorityProposalsQueryHookResult = ReturnType<typeof useGetBoundaryAuthorityProposalsQuery>;
export type GetBoundaryAuthorityProposalsLazyQueryHookResult = ReturnType<typeof useGetBoundaryAuthorityProposalsLazyQuery>;
export type GetBoundaryAuthorityProposalsSuspenseQueryHookResult = ReturnType<typeof useGetBoundaryAuthorityProposalsSuspenseQuery>;
export type GetBoundaryAuthorityProposalsQueryResult = Apollo.QueryResult<GetBoundaryAuthorityProposalsQuery, GetBoundaryAuthorityProposalsQueryVariables>;